import { useState, useMemo, useCallback } from 'react';

/**
 * 범용 정렬 훅
 * - 배열 data를 정렬해서 반환
 * - fieldKey 기준 asc/desc 토글
 */
export default function useSort(initialData = [], defaultSort = null) {
  const [sortField, setSortField] = useState(defaultSort?.field || null); // 현재 정렬 기준 key
  const [sortDirection, setSortDirection] = useState(defaultSort?.direction || 'asc'); // asc | desc

  /** 정렬 실행 */
  const sortedData = useMemo(() => {
    if (!sortField) return initialData;

    const sorted = [...initialData].sort((a, b) => {
      const av = a[sortField];
      const bv = b[sortField];

      // 숫자 비교
      if (typeof av === 'number' && typeof bv === 'number') {
        return sortDirection === 'asc' ? av - bv : bv - av;
      }

      // 날짜 비교 지원
      const aDate = new Date(av);
      const bDate = new Date(bv);
      if (!isNaN(aDate) && !isNaN(bDate)) {
        return sortDirection === 'asc' ? aDate - bDate : bDate - aDate;
      }

      // 문자열 비교
      return sortDirection === 'asc'
        ? String(av).localeCompare(String(bv))
        : String(bv).localeCompare(String(av));
    });

    return sorted;
  }, [initialData, sortField, sortDirection]);

  /** 헤더 클릭 시 실행 */
  const handleSort = useCallback(
    (fieldKey) => {
      if (sortField === fieldKey) {
        setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
      } else {
        setSortField(fieldKey);
        setSortDirection('asc');
      }
    },
    [sortField],
  );

  return {
    sortedData,
    sortField,
    sortDirection,
    handleSort,
  };
}
